(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    // ===== 排序下拉（桌面端） =====
    const sortSelect = document.getElementById('cc-sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', (e) => {
        const url = new URL(window.location);
        url.searchParams.set('sort_by', e.target.value);
        window.location.href = url.toString();
      });
    }

    // ===== 桌面端筛选 Radio =====
    const filterRadios = document.querySelectorAll('input[name="cc_dynamic_filter"]');
    if (filterRadios.length > 0) {
      const urlParams = new URLSearchParams(window.location.search);
      let matched = false;

      filterRadios.forEach(radio => {
        if (radio.value === 'clear') return;
        const type = radio.dataset.type;
        const value = radio.dataset.value;
        const paramName = getParamName(type);
        if (paramName && urlParams.get(paramName) === value) {
          radio.checked = true;
          matched = true;
        }
      });

      if (!matched) {
        const clearRadio = document.querySelector('input[name="cc_dynamic_filter"][value="clear"]');
        if (clearRadio) clearRadio.checked = true;
      }

      filterRadios.forEach(radio => {
        radio.addEventListener('change', (e) => {
          const url = new URL(window.location);
          if (e.target.value === 'clear') {
            url.searchParams.delete('filter.p.tag');
            url.searchParams.delete('filter.p.product_type');
            url.searchParams.delete('filter.v.vendor');
            url.searchParams.delete('filter.p.availability');
          } else {
            const type = e.target.dataset.type;
            const value = e.target.dataset.value;
            const paramName = getParamName(type);
            if (paramName) {
              url.searchParams.delete('filter.p.tag');
              url.searchParams.delete('filter.p.product_type');
              url.searchParams.delete('filter.v.vendor');
              url.searchParams.delete('filter.p.availability');
              url.searchParams.set(paramName, value);
            }
          }
          window.location.href = url.toString();
        });
      });
    }

    // ===== 移动端抽屉 Radio 状态同步 =====
    const mobileRadios = document.querySelectorAll('input[name="cc_mobile_filter"]');
    if (mobileRadios.length > 0) {
      const urlParams = new URLSearchParams(window.location.search);
      let mMatched = false;

      mobileRadios.forEach(radio => {
        if (radio.value === 'clear') return;
        const paramName = getParamName(radio.dataset.type);
        if (paramName && urlParams.get(paramName) === radio.dataset.value) {
          radio.checked = true;
          mMatched = true;
        }
      });

      if (!mMatched) {
        const mClear = document.querySelector('input[name="cc_mobile_filter"][value="clear"]');
        if (mClear) mClear.checked = true;
      }
    }

    // ===== 移动端筛选抽屉 =====
    const filterBtn = document.getElementById('filter-btn');
    const filterDrawer = document.getElementById('cc-filter-drawer');
    const filterOverlay = document.getElementById('cc-filter-overlay');
    const filterClose = document.getElementById('cc-filter-close');

    if (filterBtn && filterDrawer && filterOverlay) {
      filterBtn.addEventListener('click', () => {
        filterDrawer.classList.add('cc-filter-drawer--open');
        filterOverlay.classList.add('cc-filter-overlay--visible');
        document.body.style.overflow = 'hidden';
      });

      const closeDrawer = () => {
        filterDrawer.classList.remove('cc-filter-drawer--open');
        filterOverlay.classList.remove('cc-filter-overlay--visible');
        document.body.style.overflow = '';
      };

      filterOverlay.addEventListener('click', closeDrawer);
      if (filterClose) filterClose.addEventListener('click', closeDrawer);
    }

    // ===== 移动端抽屉 Apply =====
    const filterApply = document.getElementById('cc-filter-apply');
    const sortMobile = document.getElementById('cc-sort-mobile');

    if (filterApply) {
      filterApply.addEventListener('click', () => {
        const url = new URL(window.location);

        if (sortMobile && sortMobile.value) {
          url.searchParams.set('sort_by', sortMobile.value);
        }

        const checked = document.querySelector('input[name="cc_mobile_filter"]:checked');
        if (checked) {
          url.searchParams.delete('filter.p.tag');
          url.searchParams.delete('filter.p.product_type');
          url.searchParams.delete('filter.v.vendor');
          url.searchParams.delete('filter.p.availability');

          if (checked.value !== 'clear') {
            const paramName = getParamName(checked.dataset.type);
            if (paramName) {
              url.searchParams.set(paramName, checked.dataset.value);
            }
          }
        }

        window.location.href = url.toString();
      });
    }

    // ===== 移动端加载更多 =====
    const loadMoreBtn = document.getElementById('cc-load-more');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        const nextUrl = loadMoreBtn.dataset.nextUrl;
        if (!nextUrl) return;
        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = 'Loading...';

        fetch(nextUrl)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newItems = doc.querySelectorAll('.cc-product-item');
            const grid = document.querySelector('.cc-product-grid');
            if (grid && newItems.length > 0) {
              newItems.forEach(item => grid.appendChild(item));
            }
            const nextPaginate = doc.querySelector('#cc-load-more');
            if (nextPaginate && nextPaginate.dataset.nextUrl) {
              loadMoreBtn.dataset.nextUrl = nextPaginate.dataset.nextUrl;
              loadMoreBtn.disabled = false;
              loadMoreBtn.textContent = 'Load More';
            } else {
              loadMoreBtn.remove();
            }
          })
          .catch(() => {
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Load More';
          });
      });
    }

    // ===== 工具函数 =====
    function getParamName(type) {
      switch(type) {
        case 'tag': return 'filter.p.tag';
        case 'product_type': return 'filter.p.product_type';
        case 'vendor': return 'filter.v.vendor';
        case 'availability': return 'filter.p.availability';
        default: return '';
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
